/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AfterViewInit, Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'form'
})
export class FormDirective implements AfterViewInit {
    /**
     * If set trigger the find input function when the parent has loaded.
     * @param state
     */
    @Input() set loaded(state: boolean) {
        this._loaded = state;
        if (state && !this.disableFocus) {
            this.findInputAndSetFocus();
        }
    }

    /**
     * Disable focus gives you the option to disable the focus for a specific form.
     * @param condition
     */
    @Input() set disableFocus(condition: boolean) {
        this._disableFocus = condition !== false;
    }

    /**
     * Store if the parent has loaded
     * @private
     */
    private _loaded: boolean = true;

    /**
     * Store if focus has been disabled.
     * @private
     */
    private _disableFocus: boolean = false;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
    ) {
    }

    get loaded(): boolean {
        return this._loaded;
    }

    get disableFocus(): boolean {
        return this._disableFocus;
    }

    ngAfterViewInit(): void {
        if (this.loaded && !this.disableFocus) {
            this.findInputAndSetFocus();
        }
    }

    @HostListener('document:keydown', ['$event'])
    public clickSubmitButtonOnEnter(event: KeyboardEvent): void {
        if (event.key === 'Enter' && (event.ctrlKey === true || event.metaKey === true)) {
            const element = this.renderer.selectRootElement('button.primary:not([disabled])', true);
            if (element) {
                element.click();
            }
        }
    }

    /**
     * Find the first input that isn't search, not disabled and doesn't have the  class disabled.
     * @private
     */
    private findInputAndSetFocus(): void {
        const input: HTMLElement = this.el.nativeElement.querySelector(
            '.component-main form input:not([type=search]):not(.disabled):not([disabled]),' +
            '.wizard-content input:not([type=search]):not(.disabled):not(disabled)'
        );

        if (input) {
            const timerId: any = setTimeout((): void => {
                input.focus();
                clearTimeout(timerId);
            }, 0);
        }
    }
}
